<template>
  <nav
    :class="[
      'fixed w-full z-30 transition-all duration-500 ease-in-out',
      isScrolled ? 'bg-white shadow-md h-[86px]' : 'bg-white h-[112px]',
    ]"
  >
    <div
      class="w-[94%] md:w-[75%] 2xl:w-[60%] mx-auto flex justify-between items-center h-full"
    >
      <!-- Logo -->
      <router-link to="/" class="h-full flex items-center">
        <img
          src="../assets/logo.png"
          alt="kfscam logo"
          class="h-full object-contain"
        />
      </router-link>

      <!-- Desktop Menu -->
      <ul class="hidden md:flex items-center space-x-4">
        <li>
          <router-link
            to="/"
            class="px-4 py-2 rounded-md hover:bg-red-100"
            :class="{ 'bg-red text-white': isActive('/') }"
          >
            Home
          </router-link>
        </li>

        <!-- Services Dropdown -->
        <li class="relative group">
          <button
            class="px-4 py-2 rounded-md hover:bg-red-100 flex items-center gap-1"
            :class="{ 'bg-red text-white': isDropdownActive(services) }"
          >
            Our Services ▾
          </button>

          <ul
            class="absolute left-0 mt-2 w-64 bg-blue-900 text-white rounded-md shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all"
          >
            <li v-for="item in services" :key="item.to">
              <router-link
                :to="item.to"
                class="block px-4 py-2 hover:bg-blue-800"
              >
                {{ item.label }}
              </router-link>
            </li>
          </ul>
        </li>

        <li>
          <router-link
            to="/contact-us"
            class="px-4 py-2 rounded-md hover:bg-red-100"
            :class="{ 'bg-red text-white': isActive('/contact-us') }"
          >
            Contact Us
          </router-link>
        </li>

        <li>
          <router-link
            to="/news-event"
            class="px-4 py-2 rounded-md hover:bg-red-100"
            :class="{ 'bg-red text-white': isActive('/news-event') }"
          >
            News & Event
          </router-link>
        </li>
      </ul>

      <!-- Mobile Menu Button -->
      <button
        class="md:hidden text-3xl"
        @click="isMobileMenuOpen = !isMobileMenuOpen"
      >
        ☰
      </button>
    </div>

    <!-- Mobile Menu -->
    <div
      v-show="isMobileMenuOpen"
      class="md:hidden bg-white h-screen shadow-md border-t"
    >
      <ul class="flex flex-col p-4 space-y-2">
        <li>
          <router-link to="/" @click="closeMobile">Home</router-link>
        </li>

        <!-- Mobile Services -->
        <li>
          <button
            class="w-full text-left flex justify-between items-center"
            @click="isServiceOpen = !isServiceOpen"
          >
            Our Services
            <span>{{ isServiceOpen ? "−" : "+" }}</span>
          </button>

          <ul v-show="isServiceOpen" class="pl-4 mt-2 space-y-1">
            <li v-for="item in services" :key="item.to">
              <router-link
                :to="item.to"
                @click="closeMobile"
                class="block py-1"
              >
                {{ item.label }}
              </router-link>
            </li>
          </ul>
        </li>

        <li>
          <router-link to="/contact-us" @click="closeMobile">
            Contact Us
          </router-link>
        </li>

        <li>
          <router-link to="/news-event" @click="closeMobile">
            News & Event
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>


<script>
export default {
  name: "MainHeader",
  data() {
    return {
      isScrolled: false,
      isMobileMenuOpen: false,
      isServiceOpen: false,
      services: [
        {
          label: "Guarding and Security Services",
          to: "/our-service/guarding-security-service",
        },
        {
          label: "Electronic Security System",
          to: "/our-service/electronic-security-system",
        },
        {
          label: "Central Monitoring and Response Services",
          to: "/our-service/central-monitoring-response-service",
        },
        {
          label: "Security Training",
          to: "/our-service/security-training",
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    isActive(path) {
      return this.$route.path === path;
    },
    isDropdownActive(items) {
      return items.some((item) => this.$route.path === item.to);
    },
    closeMobile() {
      this.isMobileMenuOpen = false;
      this.isServiceOpen = false;
    },
  },
};

</script>
